/** Browser-safe normalization shared by generation errors and prompt inspection. */
export function normalizeValidationDetails(details: unknown): string[] {
  const values = Array.isArray(details) ? details : [details];

  return values.flatMap(detail => {
    if (typeof detail === "string") {
      const value = detail.trim();
      return value ? [value] : [];
    }
    if (!detail || typeof detail !== "object") return [];

    const record = detail as Record<string, unknown>;
    const message =
      typeof record.message === "string" ? record.message.trim() : "";
    const path = Array.isArray(record.path)
      ? record.path
          .filter(part => typeof part === "string" || typeof part === "number")
          .join(".")
      : "";
    if (!message) return [];
    return [path ? `${path}: ${message}` : message];
  });
}
